import { GetStaticProps, NextPage } from "next";

import { BluetoothLandingPage } from "@components/bluetooth-landing/BluetoothLandingPage";
import * as copy from "@data/ai-integration-landing/plCopy";

const IntegracjaAiWAplikacjiPage: NextPage = () => (
  <BluetoothLandingPage
    metadata={{
      title: copy.title,
      description: copy.description,
      canonicalPath: "/integracja-ai-w-aplikacji",
      lang: "pl",
      ogLocale: "pl_PL",
      structuredData: copy.structuredData,
      alternatePaths: {
        pl: "/integracja-ai-w-aplikacji",
        xDefault: "/integracja-ai-w-aplikacji",
      },
    }}
    heroCopy={copy.heroCopy}
    targetAudienceCopy={copy.targetAudienceCopy}
    valuePropositionCopy={copy.valuePropositionCopy}
    servicesCopy={copy.servicesCopy}
    processCopy={copy.processCopy}
    aboutUsCopy={copy.aboutUsCopy}
    faqCopy={copy.faqCopy}
    footerCopy={copy.footerCopy}
  />
);

export const getStaticProps: GetStaticProps = async () => ({
  props: {},
});

export default IntegracjaAiWAplikacjiPage;
